<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="inventoryManagerApp.lot.adjustment.title"></h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <div class="col-3">
                <label for="balance" jhiTranslate="inventoryManagerApp.lot.adjustment.new.balance"></label>
            </div>
            <div class="col-3">
                <input type="number" class="form-control" name="balance" id="balance" #balanceAmount="ngModel"
                       [(ngModel)]="balance" jhi-customMinEqualsValidator min="0"
                       [ngClass]="{ 'is-invalid': f.submitted && balanceAmount.invalid }"
                       [required]="true"/>
            </div>
        </div>
        <div class="mb-3 row">
            <div class="col-3">
                <label for="notes" jhiTranslate="inventoryManagerApp.lot.adjustment.notes"></label>
            </div>
            <div class="col-6">
                <textarea class="form-control" rows="4" name="notes" id="notes" [(ngModel)]="notes" [maxlength]="255" jhi-forbiddenCharactersValidator></textarea>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel"></span>
    </button>
    <button type="button" class="btn btn-primary" [disabled]="f.form.invalid" (click)="save()">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save"></span>
    </button>
</div>

